<div class="main-container">
  <form [formGroup]="deviceForm" novalidate>
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">Device Details</span>
      </div>
      <div class="page-info">
        <div class="header">UIN:</div>
        {{ uid }}
      </div>
      <div class="page-info">
        <div class="header">IMEI:</div>
        <app-common-search
          [initialSearchValue]="deviceForm?.get('search')?.value"
          [placeHolder]="'Search by IMEI and Press Enter'"
          (searchSubmit)="onSearch($event)"
        ></app-common-search>
      </div>
      <!-- Redirect Button -->
      <div class="button-group">
        @if (OTA_Batch_View) {
          <button
            class="primary-button"
            type="button"
            (click)="redirectToOTA()"
          >
            OTA <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
        }
        @if (FOTA_Batch_View) {
          <button
            class="primary-button"
            type="button"
            (click)="redirectToFOTA()"
          >
            FOTA <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
        }
      </div>
    </div>

    <!-- KPI Section -->
    <div class="kpi-section">
      <!-- Ignition On/Off -->
      <div class="kpi-card kpi-gradient-blue" tabindex="0">
        <div class="kpi-details">
          <span class="kpi-content"
            >Ignition On/Off
            <app-info-tooltip
              block
              heading="Ignition On/Off"
              [description]="kpiInfo.ignition"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{
              deviceLogin?.[0]?.ignition === '1'
                ? 'ON'
                : deviceLogin?.[0]?.ignition === '0'
                  ? 'OFF'
                  : '--'
            }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/ignition-on-off.png"
            alt="power-button"
          />
        </div>
      </div>

      <!-- Mains On/Off -->
      <div class="kpi-card kpi-gradient-purple" tabindex="0">
        <div class="kpi-details">
          <span class="kpi-content"
            >Mains On/Off
            <app-info-tooltip
              block
              heading="Mains On/Off"
              [description]="kpiInfo.mains"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ deviceLogin?.[0]?.mainInputVtg || '--' }}
            {{
              parseInt(this.deviceLogin?.[0]?.mainInputVtg) > 6
                ? 'ON'
                : parseInt(this.deviceLogin?.[0]?.mainInputVtg) < 6
                  ? 'OFF'
                  : '--'
            }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/mains-on-off.png"
            alt="mains-on-off"
          />
        </div>
      </div>

      <!-- Emergency On/Off -->
      <div class="kpi-card kpi-gradient-pink" tabindex="0">
        <div class="kpi-details">
          <span class="kpi-content"
            >Emergency On/Off
            <app-info-tooltip
              block
              heading="Emergency On/Off"
              [description]="kpiInfo.emergency"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{
              deviceLogin?.[0]?.emergency === '1'
                ? 'ON'
                : deviceLogin?.[0]?.emergency === '0'
                  ? 'OFF'
                  : '--'
            }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/emergency.png"
            alt="emergency"
          />
        </div>
      </div>

      <!-- Tamper Open/Close -->
      <div class="kpi-card kpi-gradient-orange" tabindex="0">
        <div class="kpi-details">
          <span class="kpi-content"
            >Tamper Open/Close
            <app-info-tooltip
              block
              heading="Tamper Open/Close"
              [description]="kpiInfo.tamper"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{
              deviceLogin?.[0]?.tamper === 'O'
                ? 'OPEN'
                : deviceLogin?.[0]?.tamper === 'C'
                  ? 'CLOSE'
                  : deviceLogin?.[0]?.tamper === 'W'
                    ? 'Wire Cut'
                    : deviceLogin?.[0]?.tamper === 'R'
                      ? 'Reconnected'
                      : '--'
            }}
          </span>
        </div>
        <div class="kpi-visual">
          <img loading="lazy" src="../../assets/tamper.png" alt="tamper" />
        </div>
      </div>

      <!-- ACC Calibration On/Off -->
      <div class="kpi-card kpi-gradient-green" tabindex="0">
        <div class="kpi-details">
          <span class="kpi-content"
            >ACC Calib On/Off
            <app-info-tooltip
              block
              heading="ACC Calib On/Off"
              [description]="kpiInfo.accCalib"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{
              deviceLogin?.[0]?.calibValidFlag === '1'
                ? 'ON'
                : deviceLogin?.[0]?.calibValidFlag === '0'
                  ? 'OFF'
                  : '--'
            }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/manometer.png"
            alt="manometer"
          />
        </div>
      </div>

      <!-- Wire Cut -->
      @if (projectName === 'TCU4G') {
        <div class="kpi-card kpi-gradient-yellow" tabindex="0">
          <div class="kpi-details">
            <span class="kpi-content"
              >Wire Cut
              <app-info-tooltip
                block
                heading="Wire Cut"
                [description]="kpiInfo.wireCut"
                (click)="$event.stopPropagation()"
              ></app-info-tooltip
            ></span>
            <span class="kpi-value">
              {{
                deviceHealth?.[0]?.wirecut ? deviceHealth?.[0]?.wirecut : '--'
              }}
            </span>
          </div>
          <div class="kpi-visual">
            <img
              loading="lazy"
              src="../../assets/broken-wire.png"
              alt="broken-wire"
            />
          </div>
        </div>
      }
    </div>

    <!-- Card Section -->
    <div class="row">
      <!-- Device Details -->
      <div class="col-lg-4 col-sm-12">
        <div class="component-container">
          <!-- Component Header Section -->
          <div class="component-header">
            <h6 class="component-title">Device Details</h6>
          </div>
          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>
          <!-- Component Body Section -->
          <div class="component-body">
            <table>
              <tbody>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">IMEI No</div>
                      <div class="value">{{ deviceDetails?.imei || '--' }}</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">ICCID No</div>
                      <div class="value">
                        {{ deviceDetails?.iccid || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">UIN No</div>
                      <div class="value">
                        {{ deviceDetails?.uid || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Assigned State</div>
                      <div class="value">
                        {{ deviceDetails?.state?.state || 'Unassign' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">VIN No</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.chesisNo || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Primary IP</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.primaryIp || '--' }} :
                        {{ deviceLogin?.[0]?.primaryPort || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Secondary IP</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.secondaryIp || '--' }} :
                        {{ deviceLogin?.[0]?.secondaryPort || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">CIP2 Port</div>
                      <div class="value">
                        {{ deviceDetails?.currentPort || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Firmware|GPS Details -->
      <div class="col-lg-3 col-sm-12">
        <div class="component-container">
          <!-- Component Header Section -->
          <div class="component-header">
            <h6 class="component-title">Firmware|GPS Details</h6>
            <div class="component-actions">
              <button
                type="button"
                matTooltip="Track Device"
                matTooltipPosition="below"
                class="primary-button"
                [disabled]="deviceLogin.length === 0"
                (click)="trackLocation()"
              >
                <mat-icon class="btn-icon">directions</mat-icon>
              </button>
              <button
                type="button"
                matTooltip="Current Location"
                matTooltipPosition="below"
                class="primary-button"
                [disabled]="deviceLogin.length === 0"
                (click)="
                  getLocation(deviceLogin[0].latitude, deviceLogin[0].longitude)
                "
              >
                <mat-icon class="btn-icon">location_on</mat-icon>
              </button>
            </div>
          </div>
          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>
          <!-- Component Body Section -->
          <div class="component-body">
            <table>
              <tbody>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">AF Version</div>
                      <div class="value">
                        {{
                          deviceLogin?.[0]?.ACCOLADE_FIRMWARE_VERSION || '--'
                        }}
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">UFW Version</div>
                      <div class="value">
                        {{ deviceDetails?.ufw || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Firmware Source</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.firmwareSource || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Last Login Date</div>
                      <div class="value">
                        {{
                          deviceLogin?.[0]?.createdAt
                            ? (deviceLogin?.[0]?.createdAt | date: 'dd/MM/yyyy')
                            : '--'
                        }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Last Login Time</div>
                      <div class="value">
                        {{
                          deviceLogin?.[0]?.createdAt
                            ? (deviceLogin?.[0]?.createdAt | date: 'hh:mm:ss a')
                            : '--'
                        }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Latitude</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.latitude || '--' }}
                        {{ deviceLogin?.[0]?.latitudeDir || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Longitude</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.longitude || '--' }}
                        {{ deviceLogin?.[0]?.longitudeDir || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Configuration Details -->
      <div class="col-lg-5 col-sm-12">
        <div class="component-container">
          <div class="component-header">
            <h6 class="component-title">Configuration Details</h6>
          </div>
          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>
          <!-- Component Body Section -->
          <div class="component-body">
            <table>
              <tbody>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">No. Of Fuel Tank:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['noOfFuelTank'] || '--' }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="table-cell">
                      <div class="header">P. Tank Length:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['primaryTankLen'] || '--' }}
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="table-cell">
                      <div class="header">P. Tank Height:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['primaryTankHeight'] || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">P. Tank Width:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['primaryTankWidth'] || '--' }}
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="table-cell">
                      <div class="header">P. Tank Cap:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['primaryTankCap'] || '--' }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="table-cell">
                      <div class="header">P. Tank Diameter:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['primaryTankDiameter'] || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">P. Tank Type:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['primaryTankType'] || '--' }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="table-cell">
                      <div class="header">P. Tank AFT Type:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['primaryTankAFTType'] || '--' }}
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="table-cell">
                      <div class="header">S. Tank Length:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['secondaryTankLen'] || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">S. Tank Height:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['secondaryTankHeight'] || '--' }}
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="table-cell">
                      <div class="header">S. Tank Width:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['secondaryTankWidth'] || '--' }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="table-cell">
                      <div class="header">S. Tank Cap:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['secondaryTankCap'] || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">S. Tank Diameter:</div>
                      <div class="value">
                        {{
                          deviceLogin?.[0]?.['secondaryTankDiameter'] || '--'
                        }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="table-cell">
                      <div class="header">S. Tank Type:</div>
                      <div class="value">
                        {{ deviceLogin?.[0]?.['secondaryTankType'] || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Accelerometer Details -->
      @if (projectName === 'TCU4G') {
        <div class="col-lg-6 col-sm-12">
          <div class="component-container">
            <!-- Component Header Section -->
            <div class="component-header">
              <h6 class="component-title">Accelerometer Details</h6>
            </div>
            <!-- Separator between Header and Body -->
            <div class="component-separator"></div>
            <div class="QA_table">
              <!-- table-responsive -->
              <div class="component-body">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Configuration Details</div>
                          <div class="value">
                            {{ deviceHealth?.[0]?.CALIB || '--' }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Angle Static</div>
                          <div class="value">
                            {{ deviceHealth?.[0]?.angleStatic || '--' }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Static X Axis</div>
                          <div class="value">
                            {{ deviceHealth?.[0]?.rawAxisStaticX_AXIS || '--' }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Static Y Axis:</div>
                          <div class="value">
                            {{ deviceHealth?.[0]?.rawAxisStaticY_AXIS || '--' }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Static Z Axis:</div>
                          <div class="value">
                            {{ deviceHealth?.[0]?.rawAxisStaticZ_AXIS || '--' }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Angle Motion:</div>
                          <div class="value">
                            {{ deviceHealth?.[0]?.rawAxisStaticZ_AXIS || '--' }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Motion X Axis:</div>
                          <div class="value">
                            {{ deviceHealth?.[0]?.rawAxisMotionX_AXIS || '--' }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Motion Y Axis:</div>
                          <div class="value">
                            {{ deviceHealth?.[0]?.rawAxisMotionY_AXIS || '--' }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Motion Z Axis:</div>
                          <div class="value">
                            {{ deviceHealth?.[0]?.rawAxisMotionZ_AXIS || '--' }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- SIM Data Details -->
      <div class="col-lg-6 col-sm-12">
        <div class="component-container">
          <div class="component-header">
            <h6 class="component-title">SIM Data Details</h6>
          </div>
          <div class="component-separator"></div>
          <div class="component-body">
            <table>
              <tbody>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Primary Operator:</div>
                      <div class="value">
                        {{
                          simDataDetails?.primaryOperator
                            ? simDataDetails?.primaryOperator
                            : '--'
                        }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="table-cell">
                      <div class="header">Primary Mobile Number:</div>
                      <div class="value">
                        {{
                          simDataDetails?.primaryMobileNumber
                            ? simDataDetails?.primaryMobileNumber
                            : '--'
                        }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="table-cell">
                      <div class="header">Secondary Operator:</div>
                      <div class="value">
                        {{
                          simDataDetails?.secondaryOperator
                            ? simDataDetails?.secondaryOperator
                            : '--'
                        }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Secondary Mobile Number:</div>
                      <div class="value">
                        {{
                          simDataDetails?.secondaryMobileNumber
                            ? simDataDetails?.secondaryMobileNumber
                            : '--'
                        }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="table-cell">
                      <div class="header">SIM Status:</div>
                      <div class="value">
                        {{
                          simDataDetails?.simStatus
                            ? simDataDetails?.simStatus
                            : '--'
                        }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="table-cell">
                      <div class="header">Activation Status:</div>
                      <div class="value">
                        {{
                          simDataDetails?.activationStatus
                            ? simDataDetails?.activationStatus
                            : '--'
                        }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Activation Start Date:</div>
                      <div class="value">
                        {{
                          simDataDetails?.activationStartDate
                            ? (simDataDetails?.activationStartDate
                              | date: 'dd-MMM-yyyy')
                            : '--'
                        }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="table-cell">
                      <div class="header">Activation Expiry Date:</div>
                      <div class="value">
                        {{
                          simDataDetails?.activationExpiryDate
                            ? (simDataDetails?.activationExpiryDate
                              | date: 'dd-MMM-yyyy')
                            : '--'
                        }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="table-cell">
                      <div class="header">Vahan Status:</div>
                      <div class="value">
                        {{
                          simDataDetails?.vahanStatus
                            ? simDataDetails?.vahanStatus
                            : '--'
                        }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Login Packet List -->
    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h3 class="component-title">
          Login Packets
          <app-info-tooltip
            heading="Login Packets"
            [description]="listInfo.loginPackets"
          ></app-info-tooltip>
        </h3>
        <div class="component-actions">
          <button
            type="button"
            class="primary-button"
            [disabled]="deviceLogin.length === 0"
            (click)="downloadLoginPacketData()"
          >
            Export <mat-icon class="btn-icon">download</mat-icon>
          </button>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>IMEI No.</th>
              <th>Ignition</th>
              <th>Firmware Version</th>
              <th>Firmware Source</th>
              <th>Emergency</th>
              <th>Date & Time</th>
              <th>Action</th>
            </tr>
          </thead>
          @if (deviceLogin.length > 0) {
            <tbody>
              @for (
                deviceLoginDetails of deviceLogin
                  | paginate
                    : {
                        id: 'paginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalCount,
                      };
                track deviceLoginDetails
              ) {
                <tr>
                  <td>{{ deviceLoginDetails.IMEI }}</td>
                  <td>{{ deviceLoginDetails.ignition }}</td>
                  <td>{{ deviceLoginDetails.ACCOLADE_FIRMWARE_VERSION }}</td>
                  <td>{{ deviceLoginDetails.firmwareSource }}</td>
                  <td>{{ deviceLoginDetails.emergency }}</td>
                  <td>
                    {{
                      deviceLoginDetails.createdAt
                        | date: 'dd MMM yyyy | hh:mm:ss a'
                    }}
                  </td>
                  <td>
                    <div class="action-buttons">
                      <button
                        type="button"
                        class="primary-button view-button"
                        (click)="viewLoginPacketDetails(deviceLoginDetails)"
                      >
                        <mat-icon class="btn-icon">visibility</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (deviceLogin.length === 0) {
            <tbody>
              <tr>
                <td colspan="7">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="Data not found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Footer Section -->
      <div class="component-footer">
        @if (deviceLogin.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalCount"
            [pageSize]="size"
            [currentPage]="page"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>

    <!-- Health Packet List -->
    @if (projectName === 'TCU4G') {
      <div class="component-container">
        <!-- Component Header Section -->
        <div class="component-header">
          <h3 class="component-title">
            Health Packets
            <app-info-tooltip
              heading="Health Packets"
              [description]="listInfo.healthPackets"
            ></app-info-tooltip>
          </h3>
          <div class="component-actions">
            <button
              type="button"
              class="primary-button"
              [disabled]="deviceHealth.length === 0"
              (click)="downloadHealthPacketReport()"
            >
              Export<mat-icon class="btn-icon">download</mat-icon>
            </button>
          </div>
        </div>
        <div class="component-separator"></div>
        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>UIN No.</th>
                <th>Firmware Version.</th>
                <th>UP Time.</th>
                <th>Ignition.</th>
                <th>Date & Time</th>
                <th>Action</th>
              </tr>
            </thead>
            @if (deviceHealth.length > 0) {
              <tbody>
                @for (
                  deviceHealthDetails of deviceHealth
                    | paginate
                      : {
                          id: 'paginate1',
                          itemsPerPage: size2,
                          currentPage: page2,
                          totalItems: totalCount2,
                        };
                  track deviceHealthDetails
                ) {
                  <tr>
                    <td>{{ deviceHealthDetails.UIN }}</td>
                    <td>{{ deviceHealthDetails.fwVer }}</td>
                    <td>{{ deviceHealthDetails.upTime }}</td>
                    <td>{{ deviceHealthDetails.IGN }}</td>
                    <td>
                      {{
                        deviceHealthDetails.createdAt
                          | date: 'dd MMM yyyy | hh:mm:ss a'
                      }}
                    </td>
                    <td class="action-buttons">
                      <div class="action-buttons">
                        <button
                          type="button"
                          class="primary-button view-button"
                          (click)="viewHealthPacketDetails(deviceHealthDetails)"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (deviceHealth.length === 0) {
              <tbody>
                <tr>
                  <td colspan="7">
                    <img
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="Data not Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Footer Section -->
        <div class="component-footer">
          @if (deviceHealth.length > 0) {
            <app-common-component-pagination
              [totalItems]="totalCount2"
              [pageSize]="size2"
              [currentPage]="page2"
              (pageChange)="onPageChange2($event)"
              (sizeChange)="onSizeChange2($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    }

    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">
          Device System Activity Log
          <app-info-tooltip
            heading="Device System Activity Log"
            [description]="listInfo.systemActivityLog"
          ></app-info-tooltip>
        </h6>
        <div class="component-actions">
          <button
            class="primary-button"
            (click)="DownloadOutputReport()"
            [disabled]="Responses.length === 0"
            type="button"
          >
            Download Report
            <mat-icon class="btn-icon">download</mat-icon>
          </button>
          <app-common-component-dropdown-search
            [items]="filterList"
            [initialValue]="deviceForm?.get('filter')?.value"
            [placeHolder]="'Select Activity Type'"
            (itemSelected)="onFilter($event)"
          ></app-common-component-dropdown-search>
          <app-system-activity-log-info></app-system-activity-log-info>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>IMEI</th>
              <th>Activity Type</th>
              <th>Activity Performed</th>
              <th>Packet</th>
              <th class="sticky-col-right">Activity Performed At</th>
            </tr>
          </thead>
          @if (totalLength !== 0) {
            <tbody>
              @for (
                response of Responses
                  | paginate
                    : {
                        id: 'paginate3',
                        itemsPerPage: size3,
                        currentPage: page3,
                        totalItems: totalLength,
                      };
                track response;
                let i = $index
              ) {
                @for (act of response.activities; track act; let j = $index) {
                  <tr>
                    @if (j === 0) {
                      <td [attr.rowspan]="response.activities.length">
                        {{ response.imei }}
                      </td>
                    }
                    <td>{{ act.activityType }}</td>
                    <td>{{ act.serverResponse || '--' }}</td>
                    @if (j === 0) {
                      <td [attr.rowspan]="response.activities.length">
                        {{ response.loginPacket }}
                      </td>
                      <td
                        class="sticky-col-right"
                        [attr.rowspan]="response.activities.length"
                      >
                        {{
                          response.createdAt | date: 'dd MMM yyyy | hh:mm:ss a'
                        }}
                      </td>
                    }
                  </tr>
                }
              }
            </tbody>
          }
          @if (totalLength === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                    tabindex="0"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Footer Section -->
      <div class="component-footer">
        @if (totalLength !== 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size3"
            [currentPage]="page3"
            (pageChange)="onPageChange3($event)"
            (sizeChange)="onSizeChange3($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  </form>

  <!-- Login Packet Details -->
  <div class="custom-container">
    <!-- Login Packet Details -->
    <div class="custom-modal custom-modal-m" id="loginPacketDetails">
      <div class="custom-modal-dialog">
        <div class="custom-modal-content">
          <!-- Modal Header -->
          <div class="custom-modal-header">
            <h4 class="custom-modal-title">Login Packet Details</h4>
            <button
              type="button"
              class="custom-close-btn"
              (click)="closeModal()"
            >
              &times;
            </button>
          </div>
          <!-- Modal Body -->
          <div class="custom-modal-body">
            <div class="component-container">
              <div class="component-body">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Start Char :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.['55AA']
                                ? selectedLoginPacket?.['55AA']
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">REQID_LOGIN_MSG_TATA :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.REQID_LOGIN_MSG_TATA
                                ? selectedLoginPacket?.REQID_LOGIN_MSG_TATA
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">PRTCL_VERSION_TATA :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.RTCL_VERSION_TATA
                                ? selectedLoginPacket?.RTCL_VERSION_TATA
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Time :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.Time
                                ? selectedLoginPacket?.Time
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">IMEI :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.IMEI
                                ? selectedLoginPacket?.IMEI
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">ICCID :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.ICCID
                                ? selectedLoginPacket?.ICCID
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">UIN Number :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.['UIN Number']
                                ? selectedLoginPacket?.['UIN Number']
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">ACCOLADE_FIRMWARE_VERSION :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.['ACCOLADE_FIRMWARE_VERSION']
                                ? selectedLoginPacket?.[
                                    'ACCOLADE_FIRMWARE_VERSION'
                                  ]
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Chassis No :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.chesisNo
                                ? selectedLoginPacket?.chesisNo
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Firmware Source :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.firmwareSource
                                ? selectedLoginPacket?.firmwareSource
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Primary Ip :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.primaryIp
                                ? selectedLoginPacket?.primaryIp
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Primary Port :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.['primaryPort']
                                ? selectedLoginPacket?.['primaryPort']
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Secondary Ip :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.secondaryIp
                                ? selectedLoginPacket?.secondaryIp
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Secondary Port :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.secondaryPort
                                ? selectedLoginPacket?.secondaryPort
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">No Of Fuel Tank :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.noOfFuelTank
                                ? selectedLoginPacket?.noOfFuelTank
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Primary Tank Capacity :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.primaryTankCap
                                ? selectedLoginPacket?.primaryTankCap
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Primary Tank Length :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.['primaryTankLen']
                                ? selectedLoginPacket?.['primaryTankLen']
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Primary Tank Width :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.primaryTankWidth
                                ? selectedLoginPacket?.primaryTankWidth
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Primary Tank Height :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.primaryTankHeight
                                ? selectedLoginPacket?.primaryTankHeight
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Primary Tank Diameter :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.primaryTankDiameter
                                ? selectedLoginPacket?.primaryTankDiameter
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Primary Tank Type :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.primaryTankType
                                ? selectedLoginPacket?.primaryTankType
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Primary Tank AFT Type :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.primaryTankAFTType
                                ? selectedLoginPacket?.primaryTankAFTType
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Secondary Tank Cap :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.secondaryTankCap
                                ? selectedLoginPacket?.secondaryTankCap
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Secondary Tank Length :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.secondaryTankLen
                                ? selectedLoginPacket?.secondaryTankLen
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Secondary Tank Width :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.secondaryTankWidth
                                ? selectedLoginPacket?.secondaryTankWidth
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Secondary Tank Height :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.secondaryTankHeight
                                ? selectedLoginPacket?.secondaryTankHeight
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Secondary Tank Diameter :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.secondaryTankDiameter
                                ? selectedLoginPacket?.secondaryTankDiameter
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Secondary Tank Type :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.secondaryTankType
                                ? selectedLoginPacket?.secondaryTankType
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Latitude :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.latitude
                                ? selectedLoginPacket?.latitude
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Latitude Direction :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.latitudeDir
                                ? selectedLoginPacket?.latitudeDir
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Longitude :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.longitude
                                ? selectedLoginPacket?.longitude
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Longitude Direction :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.longitudeDir
                                ? selectedLoginPacket?.longitudeDir
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Main Input Voltage :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.mainInputVtg
                                ? selectedLoginPacket?.mainInputVtg
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Internal Battery Voltage :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.intBatteryVtg
                                ? selectedLoginPacket?.intBatteryVtg
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Ignition :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.ignition
                                ? selectedLoginPacket?.ignition
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="table-cell">
                          <div class="header">Tamper :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.tamper
                                ? selectedLoginPacket?.tamper
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Emergency :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.emergency
                                ? selectedLoginPacket?.emergency
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Calibration Valid Flag :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.calibValidFlag
                                ? selectedLoginPacket?.calibValidFlag
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Error Counter :</div>
                          <div class="value">
                            {{
                              selectedLoginPacket?.gpsDataFlag
                                ? selectedLoginPacket?.gpsDataFlag
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Health Packet Details -->
  <div class="custom-container">
    <!-- Health Packet Details -->
    <div class="custom-modal custom-modal-m" id="healthPacketDetails">
      <div class="custom-modal-dialog">
        <div class="custom-modal-content">
          <!-- Modal Header -->
          <div class="custom-modal-header">
            <h4 class="custom-modal-title">Health Packet Details</h4>
            <button
              type="button"
              class="custom-close-btn"
              (click)="closeModal()"
            >
              &times;
            </button>
          </div>
          <!-- Modal Body -->
          <div class="custom-modal-body">
            <div class="component-container">
              <div class="component-body">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Start Char :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.['55AA']
                                ? selectedHealthPacket?.['55AA']
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Packet Type :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.packetType
                                ? selectedHealthPacket?.packetType
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Reserved :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.Reserved
                                ? selectedHealthPacket?.Reserved
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">UIN Number :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.UIN
                                ? selectedHealthPacket?.UIN
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Accolade Firmware Version :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.fwVer
                                ? selectedHealthPacket?.fwVer
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Up Time :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.upTime
                                ? selectedHealthPacket?.upTime
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Calibration :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.CALIB
                                ? selectedHealthPacket?.CALIB
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Angle Static :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.angleStatic
                                ? selectedHealthPacket?.angleStatic
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Static X Axis :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.rawAxisStaticX_AXIS
                                ? selectedHealthPacket?.rawAxisStaticX_AXIS
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Static Y Axis :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.rawAxisStaticY_AXIS
                                ? selectedHealthPacket?.rawAxisStaticY_AXIS
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Static Z Axis :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.rawAxisStaticZ_AXIS
                                ? selectedHealthPacket?.rawAxisStaticZ_AXIS
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Angle Motion :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.angleMotion
                                ? selectedHealthPacket?.angleMotion
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Motion X Axis :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.rawAxisMotionX_AXIS
                                ? selectedHealthPacket?.rawAxisMotionX_AXIS
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Motion Y Axis :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.rawAxisMotionY_AXIS
                                ? selectedHealthPacket?.rawAxisMotionY_AXIS
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Motion Z Axis :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.rawAxisMotionZ_AXIS
                                ? selectedHealthPacket?.rawAxisMotionZ_AXIS
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Used Heap :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.usedHeap
                                ? selectedHealthPacket?.usedHeap
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Total Heap :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.totalHeap
                                ? selectedHealthPacket?.totalHeap
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Hist Count :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.histCount
                                ? selectedHealthPacket?.histCount
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Epoch :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.epoch
                                ? selectedHealthPacket?.epoch
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Ignition :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.IGN
                                ? selectedHealthPacket?.IGN
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Wirecut :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.wirecut
                                ? selectedHealthPacket?.wirecut
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Emergency :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.emergency
                                ? selectedHealthPacket?.emergency
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">d1-d8 :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.['d1-d8']
                                ? selectedHealthPacket?.['d1-d8']
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Internal Battery Voltage :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.ntBatt
                                ? selectedHealthPacket?.ntBatt
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">External Battery Voltage :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.extBatt
                                ? selectedHealthPacket?.extBatt
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Analog Voltage 1 :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.analogV1
                                ? selectedHealthPacket?.analogV1
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Analog Voltage 2 :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.analogV2
                                ? selectedHealthPacket?.analogV2
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Box Tamper Raw :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.boxTamperRaw
                                ? selectedHealthPacket?.boxTamperRaw
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">GPS Date :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.gPSDate
                                ? selectedHealthPacket?.gPSDate
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">GPS Time :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.gPSTime
                                ? selectedHealthPacket?.gPSTime
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">GPS Fix QUA :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.gPSFixQUA
                                ? selectedHealthPacket?.gPSFixQUA
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Latitude :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.lat
                                ? selectedHealthPacket?.lat
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Latitude Dir :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.latDir
                                ? selectedHealthPacket?.latDir
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Longitude :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.long
                                ? selectedHealthPacket?.long
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Longitude Dir :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.longDir
                                ? selectedHealthPacket?.longDir
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Num Sat :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.numSat
                                ? selectedHealthPacket?.numSat
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Speed :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.speed
                                ? selectedHealthPacket?.speed
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Last Synced :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.lastSynced
                                ? selectedHealthPacket?.lastSynced
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">NW State :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.nwState
                                ? selectedHealthPacket?.nwState
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">CSQ :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.CSQ
                                ? selectedHealthPacket?.CSQ
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">CREG :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.CREG
                                ? selectedHealthPacket?.CREG
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">CGREG :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.CGREG
                                ? selectedHealthPacket?.CGREG
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">SOCKET STATE :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.SOCKETSTATE
                                ? selectedHealthPacket?.SOCKETSTATE
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">MQTT :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.mqtt
                                ? selectedHealthPacket?.mqtt
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Operator Name :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.oprName
                                ? selectedHealthPacket?.oprName
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Switch Retry Count :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.switchRetryCount
                                ? selectedHealthPacket?.switchRetryCount
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Reboot Counter :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.rebootCounter
                                ? selectedHealthPacket?.rebootCounter
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">Can Bus Status :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.canBusStatus
                                ? selectedHealthPacket?.canBusStatus
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">GPS Firmware Version :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.gpsFwVersion
                                ? selectedHealthPacket?.gpsFwVersion
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="table-cell">
                          <div class="header">GSM Firmware Version :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.gsmFwVersion
                                ? selectedHealthPacket?.gsmFwVersion
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">Footer :</div>
                          <div class="value">
                            {{
                              selectedHealthPacket?.footer
                                ? selectedHealthPacket?.footer
                                : '--'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
